var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CourseVideoSeting"},[_c('a-card',{staticClass:"card",attrs:{"bordered":false}},[_c('BaseSet')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }